import { Avatar, Heading } from '@lmc/ui-kit'
import { ListItem } from '@lmc/ui-kit/src/dataDisplay'
import { Button, Text } from '@lmc/ui-kit/src/general'
import { useNavigate } from 'react-router-dom'
import { styled } from 'styled-components'
import dayjs from 'dayjs'
import { Absence, AbsenceType, User } from '@lmc/ts-common'
import { useTranslation } from 'react-i18next'

type AbsenceItemProps = {
  absence: Absence
  user: User | undefined
  absenceType: AbsenceType | undefined
  all?: boolean
}

const dateFormat = 'DD MMMM YYYY'

const AbsenceItem = ({ absence, user, absenceType, all }: AbsenceItemProps) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const getSubtitle = () => {
    const userName = `${user?.name.first} ${user?.name.last}`
    const durationDays = Math.ceil(
      dayjs(absence?.endDate).diff(absence?.startDate, 'day', true)
    )
    const durationHours = Math.ceil(
      dayjs(absence?.endDate).diff(absence?.startDate, 'hour', true)
    )
    const durationString = durationDays
      ? durationDays === 1
        ? '1 day'
        : `${durationDays} days`
      : `${durationHours} hours`
    return [userName, absenceType?.name, durationString].join(' · ')
  }

  const dateString = `${dayjs(absence.startDate).format(dateFormat)} -  ${dayjs(
    absence.endDate
  ).format(dateFormat)}`

  return (
    <AbsenceListItem
      icon={
        all ? (
          // @ts-ignore
          <Avatar size={40} url={user?.picture} />
        ) : (
          <DurationIcon>
            <DurationAbbreviation level={4}>
              {absenceType?.abbreviation}
            </DurationAbbreviation>
          </DurationIcon>
        )
      }
      title={<Heading level={4}>{dateString}</Heading>}
      subtitle={<Subtitle>{getSubtitle()}</Subtitle>}
      rightChildren={
        <Button variant="text" onClick={() => navigate(absence.id)}>
          <Text weight="medium">{t('VIEW')}</Text>
        </Button>
      }
    />
  )
}

const Subtitle = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color4};
`

const AbsenceListItem = styled(ListItem)`
  background-color: ${(props) => props.theme.color.neutral.color11};
`

const DurationAbbreviation = styled(Heading)`
  color: white;
`

const DurationIcon = styled.div`
  background-color: ${(props) => props.theme.color.background.secondary};
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
`

export default AbsenceItem
